const mod = (n, m) => ((n % m) + m) % m;

const carousel = (targetCarousel: HTMLElement, layout: string) => {
  let interval;
  const animation = 500;
  const unit = layout === "desktop" ? "px" : "%";
  const carouselSlider = targetCarousel.querySelector<HTMLElement>(`[data-carousel-slider]`);
  const carouselSlides = carouselSlider.querySelectorAll<HTMLElement>(`[data-carousel-slide]`);
  const carouselContents = targetCarousel.querySelectorAll<HTMLElement>(`[data-carousel-content]`);
  const autoPlaySetting = targetCarousel.dataset.autoPlay;
  const slideDuration = targetCarousel.dataset.slideDuration;
  const pause = parseInt(slideDuration) * 1000;

  let touchStartClientX = 0;
  let touchCurrentClientX = 0;

  const itemWidthArray = [];
  const carouselSliderWidth = carouselSlider.parentElement.clientWidth;
  let showCount = 0;
  let tempSum = 0;

  carouselSlides.forEach((slide: HTMLElement) => {
    const itmWidth = slide.offsetWidth;
    itemWidthArray.push(itmWidth);
    tempSum += itmWidth;
    if (tempSum <= carouselSliderWidth) {
      showCount++;
    }
  });

  const navigationButtons = [];

  const totalSlideCount = carouselSlides.length;
  let currentIndex = layout === "mobile" ? 1 : 0;

  const goto = (index) => {
    currentIndex = index;
    anim();
  };

  const getMoveDistance = (index) => {
    let sum = 0;
    for (let i = 0; i < index; i++) sum += itemWidthArray[i] + 5;
    return -sum;
  };

  const checkContentVisibility = () => {
    const cMod = mod(currentIndex, totalSlideCount);
    carouselContents.forEach((itm, i) => itm.classList.toggle("hidden", cMod !== i));
  };

  const styleNavigationButton = () => {
    if (layout === "mobile") {
      const cMod = mod(currentIndex, totalSlideCount);
      navigationButtons.forEach((navigationButton, i) =>
        navigationButton.classList.toggle("!bg-black", cMod === i)
      );
    }
  };

  const anim = (ms = animation, touchDistance = 0) => {
    const distance =
      layout === "mobile" ? (-currentIndex - 1) * 100 : getMoveDistance(currentIndex);
    carouselSlider.style.transitionDuration = `${ms}ms`;

    if (touchDistance) {
      carouselSlider.style.transform = `translate3d(calc(${distance}${unit} + ${touchDistance}px), 0, 0)`;
    } else {
      carouselSlider.style.transform = `translate3d(${distance}${unit}, 0, 0)`;
    }
    checkContentVisibility();
    styleNavigationButton();
  };

  const next = () => {
    if (currentIndex >= totalSlideCount) return;
    currentIndex += 1;
    anim();
  };

  const prev = () => {
    if (currentIndex <= -1) return; // prevent blanks on fast prev-click
    currentIndex -= 1;
    anim();
  };

  const play = () => {
    interval = setInterval(next, pause + animation);
  };

  const stop = () => {
    clearInterval(interval);
  };

  const handleTouchStart = (event) => {
    touchStartClientX = event.touches[0].clientX;
    touchCurrentClientX = touchStartClientX;
  };

  const handleTouchMove = (event) => {
    event.preventDefault();

    touchCurrentClientX = event.touches[0].clientX;
    const distanceX = touchCurrentClientX - touchStartClientX;
    anim(0, distanceX);
  };

  const handleTouchEnd = (event) => {
    event.preventDefault();
    const distanceX = touchCurrentClientX - touchStartClientX;
    if (distanceX < -50) {
      next();
    } else if (distanceX > 50) {
      if (layout === "desktop" && currentIndex === 0) {
        anim(animation, 0);
        return;
      }
      prev();
    } else {
      anim(animation, 0);
    }
    touchStartClientX = 0;
    touchCurrentClientX = 0;
  };

  if (totalSlideCount < showCount) {
    checkContentVisibility();
    styleNavigationButton();
    return;
  }

  for (let i = 0; i < totalSlideCount; i++) {
    const navigationButton = document.createElement("button");
    const classListString = "w-3 h-3 border-black bg-black/20 cursor-pointer rounded-full";
    navigationButton.setAttribute("type", "button");
    classListString
      .split(" ")
      .forEach((classString) => navigationButton.classList.add(classString));
    navigationButton.onclick = () => goto(i);
    navigationButtons.push(navigationButton);
  }

  if (layout === "desktop") {
    targetCarousel.querySelector("[data-slide-next]").addEventListener("click", () => {
      next();
    });
  }

  if (autoPlaySetting === "true") {
    carouselSlider.addEventListener("pointerenter", stop);
    carouselSlider.addEventListener("pointerleave", play);
  }

  carouselSlider.addEventListener("touchstart", handleTouchStart);
  carouselSlider.addEventListener("touchmove", handleTouchMove);
  carouselSlider.addEventListener("touchend", handleTouchEnd);

  carouselSlider.addEventListener("transitionend", () => {
    if (currentIndex <= -1) currentIndex = totalSlideCount - 1;
    if (currentIndex >= totalSlideCount) currentIndex = 0;
    anim(0);
  });

  carouselSlider.append(carouselSlides[0].cloneNode(true));

  if (layout === "desktop") {
    for (let i = 2; i <= showCount; i++) {
      const mod = (i - 1 + totalSlideCount) % totalSlideCount;
      carouselSlider.append(carouselSlides[mod].cloneNode(true));
    }
  } else {
    carouselSlider.prepend(carouselSlides[totalSlideCount - 1].cloneNode(true));
    targetCarousel.querySelector("[data-carousel-navigation]").append(...navigationButtons);
  }

  anim();

  if (autoPlaySetting === "true") {
    play();
  }
};

export const initPartnerSlider = async () => {
  document.querySelectorAll("[data-partner-slider]").forEach((e: HTMLElement) => {
    const layout = e.scrollWidth < 768 ? "mobile" : "desktop";
    carousel(e, layout);
  });
};
